const FOCUSABLE =
  "input,select,textarea,button,[tabindex]:not([tabindex='-1'])";

const focusableIn = (cell) => {
  if (!cell) return null;
  const candidates = cell.querySelectorAll(FOCUSABLE);
  for (const el of candidates) {
    if (el.disabled) continue;
    if (el.getAttribute("aria-hidden") === "true") continue;
    if (el.type === "hidden") continue;
    if (el.offsetParent === null && el.type !== "checkbox") continue;
    return el;
  }
  return null;
};

export const handleTabDown = (root) => (e) => {
  if (e.key !== "Tab" || !root.current) return;
  const cell = e.target.closest("[data-wax-row][data-wax-col]");
  if (!cell) return;
  const row = Number(cell.getAttribute("data-wax-row"));
  const col = Number(cell.getAttribute("data-wax-col"));
  const nextRow = e.shiftKey ? row - 1 : row + 1;
  const nextCell = root.current.querySelector(
    `[data-wax-row="${nextRow}"][data-wax-col="${col}"]`,
  );
  const target = focusableIn(nextCell);
  if (!target) return; // top/bottom of table — fall back to default Tab.
  e.preventDefault();
  target.focus();
  if (typeof target.select === "function") target.select();
};

const required = true;
export const keys = [
  {
    id: "wax-drag",
    label: "::",
  },
  {
    id: "wax-station",
    label: "Station",
    required,
  },
  {
    id: "wax-lead",
    label: "Lead Time",
    required,
  },
  {
    id: "wax-cycle",
    label: "Cycle",
    required,
  },
  {
    id: "wax-notes",
    label: "Notes",
  },
];
